/**
 * Shared dimension constants for the recipe graph renderer.
 * Single source of truth to avoid magic numbers scattered across files.
 */
export const NODE_RADIUS = 45;
export const NODE_SPACING = 20;
export const LEVEL_HEIGHT = 150;
